import React, { useEffect, useState } from "react";
import ExpenditureCard from "./ExpenditureCard";
import ApiManager from "../../ApiManager/ApiManager";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import NewExpenditure from "../Expenditure/NewExpenditure";

const ExpenditureDrawerTable = ({ row, from, to, drawerWidth }) => {
  const [expenditures, setExpenditures] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchExpenditures = async () => {
    setLoading(true);
    try {
      const queryObj = {
        driverId: row.driver_id,
        page_size: 1000,
        page: 1,
      };
      if (from) queryObj.from = from;
      if (to) queryObj.to = to;
      const query = new URLSearchParams(queryObj);
      const response = await ApiManager.getAllExpenditures(query);
      if (!response.ok) throw new Error("Failed to fetch expenditures");
      const data = await response.json();
      const driverPaidExpenditures = data ? data.filter(exp => exp.is_paid_by_driver === true && exp.status === 'approved') : [];
      setExpenditures(driverPaidExpenditures);
    } catch (error) {
      setExpenditures([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchExpenditures();
    // eslint-disable-next-line
  }, [row.driver_id, from, to]);

  if (loading) return <LoadingSpinner message="Loading expenditure data..." />;
  if (!expenditures.length) return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <NewExpenditure onSuccess={fetchExpenditures} />
      </div>
      No expenditure records found.
    </div>
  );

  return (
    <div style={{ padding: 8 }}>
      <div style={{ margin: 16, display: "flex", justifyContent: "flex-end" }}>
        <NewExpenditure onSuccess={fetchExpenditures} />
      </div>
      {expenditures.map((item, idx) => (
        <ExpenditureCard key={item.id || idx} expenditure={item} />
      ))}
    </div>
  );
};

export default ExpenditureDrawerTable; 